<p-messages [(value)]="messages" [enableService]="false"></p-messages>
<!-- google signin button -->
<div class="md:w-6 mx-auto mt-4"
  [ngClass]="showForm === 'login' || showForm === 'signup' ? 'block' : 'hidden'">
  <div id="googleButton"></div>
  <small class="block invalid-feedback">{{ googleSignInError }}</small>
</div>
<!-- login forms -->
<div class="md:w-6 mx-auto mt-4" [ngClass]="showForm === 'login' ? 'block' : 'hidden'">
  <p>Or, login with email and password...</p>
  <form (ngSubmit)="login()" [formGroup]="loginForm">
    <div class="field">
      <label for="loginEmail" class="block">Your email address</label>
      <input type="email" formControlName="loginEmail" pInputText id="loginEmail" #loginEmail>
      <small class="invalid-feedback">{{ emailError }}</small>
    </div>
    <div class="field">
      <label for="loginPassword" class="block">Your password</label>
      <input type="password" formControlName="loginPassword" pInputText id="loginPassword" #loginPassword>
      <small class="invalid-feedback">{{ passwordError }}</small>
    </div>
    <div>
      <button type="submit" class="p-button-primary" pButton
        [disabled]="!loginForm.touched || !loginForm.valid">Login</button>
    </div>
  </form>
  <p class="mt-4">
    Not a Partner Control Centre user yet? <a class="link" (click)="showSignup()">Sign Up</a><br>
    <span class="link" (click)="forgotPassword();">Forgot password?</span><br>
  </p>
</div>

<div class="md:w-6 mx-auto mt-4" *ngIf="showForm === 'lostpassword'">
  <h2>Change Password</h2>
  <form (ngSubmit)="changePassword()" [formGroup]="lostPasswordForm" autocomplete="off">
    <div class="field">
      <label for="currentEmail" class="block">Current email address</label>
      <input type="email" formControlName="currentEmail" pInputText id="currentEmail" #currentEmail>
      <small class="invalid-feedback">{{ emailError || 'Email address not known' }}</small>
    </div>
    <div class="field">
      <label for="newPassword" class="block">New password (minimum 8 characters)</label>
      <input type="password" formControlName="newPassword" pInputText id="newPassword" #newPassword
        autocomplete="new-password">
      <small class="invalid-feedback">{{ passwordError }}</small>
    </div>
    <div class="field">
      <label for="newPassword2" class="block">Confirm new password</label>
      <input type="password" formControlName="newPassword2" pInputText id="newPassword2" #newPassword2
        autocomplete="new-password">
      <small class="invalid-feedback">Passwords do not match</small>
    </div>
    <div class="field">
      <label for="authCode" class="block">Authentication code</label>
      <input type="text" formControlName="authCode" pInputText id="authCode"
        [placeholder]="authCodePlaceHolder" #authCode>
      <small class="invalid-feedback">{{ currentEmail.value ? 'Please enter the code emailed to ' +
        currentEmail.value : '' }}</small>
    </div>
    <div>
      <button type="submit" class="p-button-primary" pButton
        [disabled]="!lostPasswordForm.touched || !lostPasswordForm.valid">Reset Password</button>
    </div>
  </form>
  <p class="mt-4">
    <span class="link" (click)="showForm = 'login'; lostPasswordForm.reset()">Show Login Page</span>
  </p>
</div>

<!-- signup forms -->
<div class="md:w-6 sm:w-full mx-auto mt-4" *ngIf="showForm === 'signup'">
  <p>Or sign up with email...</p>
  <form (ngSubmit)="signup()" [formGroup]="signupForm" autocomplete="off">
    <div class="field">
      <label for="signupEmail" class="block">Email address</label>
      <input type="email" formControlName="signupEmail" placeholder="someone@somewhere.com" pInputText
        id="signupEmail" #signupEmail>
      <small class="invalid-feedback">{{ emailError }}</small>
    </div>
    <div>
      <button type="submit" class="p-button-primary" pButton [disabled]="!signupForm.valid">Signup</button>
    </div>
  </form>
  <p class="mt-4">
    Already a Partner Control Centre user? <a class="link"
      (click)="showForm = 'login'; signupForm.reset()">Log In</a><br>
  </p>
</div>

<div class="mt-4 md:w-6 sm:w-full mx-auto" *ngIf="showForm === 'signupconfirm'">
  <h2>Sign Up Confirmation</h2>
  <p>
    A 6 digit authentication code has been sent to {{ email }}. Please enter this code in the field
    below to confirm your email address.
  </p>
  <form (ngSubmit)="signupConfirm()" [formGroup]="signupConfirmForm" autocomplete="off" class="w-50 mx-auto">
    <div class="field">
      <label for="signupFullName" class="block">Your full name</label>
      <input type="text" formControlName="signupFullName" placeholder="Your name" pInputText
        id="signupFullName" #signupUserName>
      <small class="invalid-feedback">Please enter your full name</small>
    </div>
    <div class="field">
      <label for="signupPassword" class="block">Password (minimum 8 characters)</label>
      <input type="password" formControlName="newPassword" pInputText id="signupPassword" #signupPassword>
      <small class="invalid-feedback">{{ passwordError }}</small>
    </div>
    <div class="field">
      <label for="signupPassword2" class="block">Password confirm</label>
      <input type="password" formControlName="newPassword2" pInputText id="signupPassword2" #signupPassword2>
      <small class="invalid-feedback">Passwords do not match</small>
    </div>
    <div class="field">
      <label for="signupAuthCode" class="block">Authentication Code</label>
      <input type="text" formControlName="signupAuthCode" pInputText id="signupAuthCode" #signupAuthCode>
      <small class="invalid-feedback">Please enter a valid authentication code</small>
    </div>
    <div>
      <button type="submit" class="p-button-primary" pButton [disabled]="!signupConfirmForm.valid">Complete
        Signup</button>
    </div>
  </form>
  <p class="mt-4">
    <a class="link" (click)="showForm = 'signup'; signupConfirmForm.reset()">Back</a><br>
  </p>
</div>
